import "./associadosEng.css";
import AprovadorEng from "../../componentes/fluxo-engenheiro/AprovadorEng/AprovadorEng";
import HeaderProtected from "../../componentes/headerProtected/header";
import Sidebar from "../../componentes/sideBar/SideBar";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";

const AssociadosEng = () => {
  return (
    <>
      <Sidebar />
      <HeaderProtected />
      <div className="associadosEngMain">
        <AprovadorEng />
      </div>
      <SupportFooter />
    </>
  );
};

export default AssociadosEng;